import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { CommandService } from '../../shared/services/command.service';
import { DeviceInputBaseComponent } from '../device-input-base.component';
import {
    CommandOptimizationRenderingService
} from '@caslink/device-client/ng-app/shared/services/command-optimization-rendering.service';

@Component({
    selector: 'dl-static-element-list',
    templateUrl: './static-element-list-input.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StaticElementListInputComponent extends DeviceInputBaseComponent {
    public static $name: string = 'staticElementList';

    constructor(
        private commandService: CommandService,
        protected commandOptimizationRenderingService: CommandOptimizationRenderingService,
        protected cdr: ChangeDetectorRef,
    ) {
        super(commandService, commandOptimizationRenderingService, cdr);
    }
}
